import { Link as MUILink } from '@mui/material'
import { forwardRef, useMemo } from 'react'
import type { Path } from 'react-router'
import { type LinkProps, Link as ReactRouterLink } from 'react-router-dom'

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const to = useMemo<Partial<Path>>(() => {
    if (typeof props.to === 'string') {
      const [pathname, search] = props.to.split('?')

      return {
        pathname,
        search,
      }
    }

    return props.to
  }, [props.to])

  const toString = useMemo(
    () => (to.search ? `${to.pathname ?? ''}?${to.search}` : to.pathname),
    [to.pathname, to.search],
  )

  const isExternalLink = useMemo<boolean>(() => to.pathname?.startsWith('http') ?? false, [to])

  if (isExternalLink) {
    return (
      <MUILink
        {...props}
        ref={ref}
        href={toString}
        target={isExternalLink ? '_blank' : props.target}
        rel={isExternalLink ? 'noopener, noreferrer' : props.target}
      />
    )
  }

  return <ReactRouterLink {...props} ref={ref} to={to} />
})
